<div
	id="config-content"
	class="row user-card shadow configAvailability"
	(window:resize)="onResize()"
>
	<div
		*ngIf="!userPref || isLoading"
		style="margin-top: 60px; padding: 50px 20px; text-align: center"
	>
		<freud-loader size="sm" [bgColor]="false"></freud-loader>
	</div>

	<!-- Period. -->
	<div *ngIf="userPref && !isLoading" class="configAvailabilityPeriod">
		<p>{{ 'GENERAL.PERIOD' | translate | uppercase }}</p>

		<table class="tableAvailPeriod">
			<!-- From date. -->
			<tr>
				<td class="tdLabel">{{ 'GENERAL.FROM' | translate | uppercase }}</td>
				<td>
					<p-calendar
						[readonlyInput]="true"
						[(ngModel)]="newPeriodDate[0]"
						[selectionMode]="'single'"
						dateFormat="dd/mm/yy"
						[placeholder]="newPeriodDate[0]"
						inputStyleClass="calendar-availabilities"
						[monthNavigator]="true"
						yearRange="2000:2030"
						inputId="navigators"
						[yearNavigator]="false"
					>
					</p-calendar>
				</td>
			</tr>
			<tr>
				<td class="tdLabel">{{ 'GENERAL.TO' | translate | uppercase }}</td>
				<td>
					<p-calendar
						[readonlyInput]="true"
						[(ngModel)]="newPeriodDate[1]"
						[selectionMode]="'single'"
						dateFormat="dd/mm/yy"
						[placeholder]="newPeriodDate[1]"
						inputStyleClass="calendar-availabilities"
						[monthNavigator]="true"
						yearRange="2000:2030"
						inputId="navigators"
						[yearNavigator]="false"
					>
					</p-calendar>
				</td>
			</tr>
			<tr>
				<td colspan="2">
					<div class="important">
						{{ 'TOOLTIPS.AVAILABILITIES.MAXVALUE' | translate }}
					</div>
				</td>
			</tr>
		</table>

		<p style="margin-top: 30px">
			{{ 'GENERAL.TIMEZONE' | translate | uppercase }}
		</p>

		<p class="sec-info" style="font-size: 13px">{{ slotTimezone }}</p>

		<hr />

		<a
			*ngIf="!slots"
			class="aShowAll"
			(click)="showAllAvailabilities()"
			pTooltip="{{ 'TOOLTIPS.AVAILABILITIES.SHOWALL' | translate }}"
			tooltipPosition="top"
		>
			{{ 'GENERAL.VIEWALLAVAILABILITIES' | translate }}
		</a>
	</div>

	<!-- Slots. -->
	<div
		*ngIf="newPeriodDateFrom && newPeriodDateTo && !isLoading"
		class="configAvailabilitySlots"
	>
		<!-- This table holds all lines with weekdays and timetables. -->
		<table
			*ngIf="slots && slots.weekdaySlots.length > 0"
			class="tabTimetables"
			style="width: 100%"
		>
			<!-- Table header. -->
			<thead>
				<tr>
					<td style="width: 40%">
						{{ 'GENERAL.WEEKDAYS' | translate | uppercase }}
					</td>
					<td style="width: 60%">
						{{ 'GENERAL.RANGEOFHOURS' | translate | uppercase }}
					</td>
				</tr>
			</thead>

			<!-- Table body. -->
			<tbody>
				<!-- Each line match a slot. -->
				<tr *ngFor="let wd of slots.weekdaySlots">
					<!-- Weekday. -->
					<td class="tdTimetables" [attr.data-key]="wd.key">
						<select
							class="selectMode selWeekday form-control"
							style="display: inline; line-height: 40px; margin-right: 5px"
							pTooltip="{{
								'TOOLTIPS.AVAILABILITIES.SELECTWEEKDAY' | translate
							}}"
							tooltipPosition="top"
							(change)="changeSelectedWeekday(wd.key)"
						>
							<option
								*ngFor="let day of calendarLabels.dayNames; let i = index"
								[selected]="i == wd.dayOfWeek"
								[value]="i"
							>
								{{ day }}
							</option>
						</select>
					</td>
					<!-- /Weekday. -->

					<!-- Timetables. -->
					<td class="tdTimetables">
						<!-- Container for group timetables. -->
						<div class="tdTimetablesContainer">
							<!-- Code for each timetable. -->
							<div
								*ngFor="let item of wd.items"
								class="divTimeTableItem"
								[attr.data-key]="item.key"
							>
								<!-- Hour from. -->
								<select
									class="selectMode selHourSlotFrom form-control"
									style="line-height: 40px"
									(change)="fromHourSelected(wd.key, item.key)"
									pTooltip="{{
										'TOOLTIPS.AVAILABILITIES.SELECTINITIALHOUR' | translate
									}}"
									tooltipPosition="top"
								>
									<option
										*ngFor="let hour of hoursList"
										[value]="hour"
										[selected]="hour == item.startString"
										[ngClass]="{
											halfHourSelectItem: hour.indexOf(':30') > -1,
											fullHourSelectItem: hour.indexOf(':30') == -1
										}"
									>
										{{ hour }}
									</option>
								</select>

								<!-- To label. -->
								<span class="spnTimetable">{{
									'GENERAL.TO' | translate | uppercase
								}}</span>

								<!-- Hour to. -->
								<select
									class="selectMode selHourSlotTo form-control"
									style="line-height: 40px"
									(change)="fromHourSelected(wd.key, item.key)"
									pTooltip="{{
										'TOOLTIPS.AVAILABILITIES.SELECTFINALHOUR' | translate
									}}"
									tooltipPosition="top"
								>
									<option
										*ngFor="let hour of hoursList"
										[value]="hour"
										[selected]="hour == item.endString"
										[ngClass]="{
											halfHourSelectItem: hour.indexOf(':30') > -1,
											fullHourSelectItem: hour.indexOf(':30') == -1
										}"
									>
										{{ hour }}
									</option>
								</select>

								<!-- Remove and add item icons. -->
								<span class="spnTimetable spnBtns">
									<img
										class="imgRemoveItem"
										src="/assets/images/icons/delete2.svg"
										(click)="removeHourInterval(wd.key, item.key)"
										pTooltip="{{
											'TOOLTIPS.AVAILABILITIES.REMOVERANGEOFHOURS' | translate
										}}"
										tooltipPosition="top"
									/>
									<img
										class="imgAddItem"
										src="/assets/images/icons/add2.svg"
										(click)="addHourInterval(wd.key)"
										pTooltip="{{
											'TOOLTIPS.AVAILABILITIES.ADDRANGEOFHOURS' | translate
										}}"
										tooltipPosition="top"
									/>
								</span>
							</div>
						</div>
						<!-- /tdTimetablesContainer. -->
					</td>
					<!-- /Timetables. -->
				</tr>
				<!-- Line end. -->
			</tbody>
		</table>

		<!-- Add slots message. -->
		<div
			*ngIf="!slots || slots.weekdaySlots.length == 0"
			class="alert alert-info"
		>
			<fa-icon icon="exclamation-circle"></fa-icon>
			{{ 'MESSAGES.AVAILABILITIES.ADDPERIODSLOTS' | translate }}
		</div>

		<!-- Add new weekday item. -->
		<p class="addDayBlock">
			<span
				(click)="addDayBlock()"
				pTooltip="{{ 'TOOLTIPS.AVAILABILITIES.ADDDAYHOUR' | translate }}"
				tooltipPosition="top"
			>
				<img class="imgAddDayHour" src="/assets/images/icons/add2.svg" />
				{{ 'OPERATIONS.ADDDAYHOUR' | translate | uppercase }}
			</span>
		</p>

		<!-- Cancel and save buttons. -->
		<div *ngIf="slots && slots.weekdaySlots.length > 0" class="slotsButtons">
			<!-- Cancel. -->
			<button
				type="button"
				class="btn btn-cancel"
				(click)="cancelAll()"
				pTooltip="{{ 'TOOLTIPS.AVAILABILITIES.CANCEL' | translate }}"
				tooltipPosition="top"
			>
				{{ 'OPERATIONS.CANCEL' | translate | uppercase }}
			</button>

			<!-- Save. -->
			<button
				*ngIf="!slots.id"
				type="button"
				class="btn btn-primary"
				(click)="saveAll()"
				pTooltip="{{ 'TOOLTIPS.AVAILABILITIES.SAVE' | translate }}"
				tooltipPosition="top"
			>
				{{ 'OPERATIONS.SAVE' | translate | uppercase }}
			</button>

			<!-- Edit. -->
			<button
				*ngIf="slots.id"
				type="button"
				class="btn btn-primary"
				(click)="saveUpdates()"
				pTooltip="{{ 'TOOLTIPS.AVAILABILITIES.SAVEUPDATES' | translate }}"
				tooltipPosition="top"
			>
				{{ 'OPERATIONS.SAVE' | translate | uppercase }}
			</button>
		</div>
	</div>

	<!-- Select a period. -->
	<div
		*ngIf="!newPeriodDateFrom || (!newPeriodDateTo && !isLoading)"
		class="configAvailabilitySlots"
	>
		<div class="alert alert-info">
			<fa-icon icon="exclamation-circle"></fa-icon>
			{{ 'MESSAGES.AVAILABILITIES.SELECTPERIOD' | translate }}
		</div>
	</div>
</div>
